// extracted by mini-css-extract-plugin
export default {"message-container":"NotFoundPage_message-container__Z-bcz","message":"NotFoundPage_message__G7Xf0"};